export const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: "300px",
        gap: 1,
        p: 3
    },
    waitImage: {
        width: "180px",
        height: "auto"
    },
    undrawImage: {
        width: "200px",
        height: "auto"
    },
    previewHeader: {
        display: "flex",
        alignItems: "center"
    },
    adapterIcon: {
        width: "24px",
        height: "24px"
    },
    tableContainer: {
        pb: 1,
        overflow: "auto"
    }
};
